import CenterLayout from "@/layouts/center";

export default [
	{
	    path: "/auth",
	    component: CenterLayout,
	    children: [
	      {
	        path: "login",
	        name: "auth.login",
	        component: () =>
	          import(/* webpackChunkName: "auth" */ "@/views/auth/login/index.vue")
	      },
	      {
	        path: "forgot",
	        name: "auth.forgot",
	        component: () =>
	          import(/* webpackChunkName: "auth" */ "@/views/auth/forgot/index.vue")
	      },
	      {
	        path: "reset",
	        name: "auth.reset",
	        component: () =>
	          import(/* webpackChunkName: "auth" */ "@/views/auth/reset/index.vue")
	      }
	    ]
	}
]